export const iconFontAwesomeMaritimeAnchorCircleXmark = (
	<i className="fa-solid fa-anchor-circle-xmark"></i>
);
